import React, {useEffect, useState} from 'react';
import {Formik, Field} from "formik";
import AppCheckbox from "../../../../components/Input/AppCheckbox";
import {Box, Typography} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {fetchClientDetail, reduceUpdateClientNotifyEmail} from "../../../../store/slices/client";
import {getAuthInfo, getMe} from "../../../../store/slices/auth";
import AppColor from "../../../../utilities/AppColor";
import AppButton from "../../../../components/CustomButtons/AppButton";
import {makeStyles} from "@material-ui/core/styles";
import { SYSTEM_ROLE} from "../../../../config/AppConfig";
import { fetchCompanyDetail } from 'store/slices/company';
import { reduceUpdateCompanyNotifyEmail } from 'store/slices/company';

const useStyles = makeStyles(() => ({
    text: {
        fontSize: 14,
        color: AppColor.black
    }
}))

const EmailAlertForm = () => {
    const {t} = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector(getAuthInfo);
    const [submitting, setSubmitting] = useState(false);
    const initForm = {
        isEmailAppliedJob: false,
        isEmailBooking: false
        // isEmailBilling: false,
        // isEmailStatusParticipant: false
    }
    const [initializeData, setInitializeData] = useState({
        isEmailAppliedJob: false,
        isEmailBooking: false,
        // isEmailBilling: false,
        // isEmailStatusParticipant: false,
        // isEmailCreatedParticipant: false
    });
    // const isSCO = user.clientType === CLIENT_TYPE.SINGLE_USER_COORDINATOR || user.clientType === CLIENT_TYPE.MULTIPLE_USER_COORDINATOR || user.role === SYSTEM_ROLE.COMPANY;
    const _submit = async (data) => {
        setSubmitting(true);
        const {payload} = await dispatch(user.role === SYSTEM_ROLE.COMPANY ? reduceUpdateCompanyNotifyEmail(data) : reduceUpdateClientNotifyEmail(data));
        setSubmitting(false);
        if (payload) {
            _loadData();
        }
    }
    const _loadData = async () => {
        let authUser = user;
        if (!user) {
            const {payload} = await dispatch(getMe());
            if (payload) {
                authUser = payload;
            }
        }
        if (authUser.role === SYSTEM_ROLE.COMPANY) {
            const {payload} = await dispatch(fetchCompanyDetail({
                companyId: authUser.companyId
            }));
            if (payload) {
                setInitializeData({
                    ...initForm,
                    isEmailAppliedJob: payload.companyUser.emailAppliedJob,
                    isEmailBooking: payload.companyUser.emailBooking,
                    // isEmailBilling: payload.companyUser.emailBilling,
                    // isEmailStatusParticipant: payload.companyUser.emailStatusParticipant,
                    // isEmailCreatedParticipant: payload.companyUser.emailCreatedParticipant
                })
            }
        } else {
            const {payload} = await dispatch(fetchClientDetail({
                clientId: authUser.clientId,
                companyId: authUser.companyId
            }));
            if (payload) {
                setInitializeData({
                    ...initForm,
                    isEmailAppliedJob: payload.client.emailAppliedJob,
                    isEmailBooking: payload.client.emailBooking,
                    // isEmailBilling: payload.clientUser.isEmailBilling,
                    // isEmailStatusParticipant: payload.clientUser.isEmailStatusParticipant
                })
            }
        }
        
    }
    useEffect(() => {
        _loadData();
    }, []);

    return (
        <Formik
            initialValues={initializeData}
            onSubmit={_submit}
            enableReinitialize
        >
            {({handleSubmit}) => (
                <>
                    <Box display="flex" flexDirection="column" my={2}>
                        <Field
                            component={AppCheckbox}
                            name="isEmailAppliedJob"
                            label={t('text.checkbox_email_applied_job')}
                        />
                        <Field
                            component={AppCheckbox}
                            name="isEmailBooking"
                            label={t('text.checkbox_email_booking')}
                        />
                        {/* <Field
                            component={AppCheckbox}
                            name="isEmailBilling"
                            label={t('text.checkbox_email_billing')}
                        />
                        {isSCO && (
                            <>
                                {user.role === SYSTEM_ROLE.COMPANY && 
                                    <Field
                                    component={AppCheckbox}
                                    name="isEmailCreatedParticipant"
                                    label={t('text.checkbox_create_participant')}
                                />
                                }
                                <Field
                                    component={AppCheckbox}
                                    name="isEmailStatusParticipant"
                                    label={t('text.checkbox_email_participant_approval')}
                                />
                            </>
                        )} */}
                    </Box>
                    <Typography variant={"body2"} className={classes.text}>
                        {t('text.email_notification_note')}
                    </Typography>
                    <Box display="flex" justifyContent="flex-end" mt={5}>
                        <AppButton
                            label={t('button.save')}
                            onClick={handleSubmit}
                            isLoading={submitting}
                            disabled={submitting}
                        />
                    </Box>
                </>
            )}
        </Formik>
    )
}

export default EmailAlertForm;
